import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import { IoIosCloseCircle } from "react-icons/io";
import { FiUploadCloud, FiDownload } from "react-icons/fi";
import axios from 'axios';
import { Base_Url, csvuplode } from '../../../config/config';
import { toast } from 'react-toastify';
import { useMyContext } from '../../../context/MyContext';
import ConfirmBulkOrder from './ConfirmBulkOrder';
import Spinner from '../../spinner/spinner';
import Papa from 'papaparse';
 import { useNavigate } from 'react-router-dom';
import {
    FileText,
    Sparkles,
    X,
    CheckCircle,
    Eye,
    AlertCircle,
    Download,
} from "lucide-react";


const UploadBulk = ({ isopen, onClose }) => {
    const [file, setFile] = useState(null); 
    const { isDarkMode } = useMyContext();
    const [reqBody, setReqBody] = useState([])
    const [loading, setloading] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [csvParsed, setCsvParsed] = useState(false);
    const [previewData, setPreviewData] = useState([]);

    const navigate = useNavigate();

    const handleViewClick = () => {
        setIsPopupOpen(true);
    };
    const handleClose = () => {
        setIsPopupOpen(false);
    };


    const handlePreviewClick = () => {
        if (previewData.length > 0) {
            setShowPreview(true);
        }
    };

    const closePreviewModal = () => {
        setShowPreview(false);
    };

    const handleCloseBulk = () => {
        onClose();
        setFile(null);
        setPreviewData([]);
        setCsvParsed(false);
    };


    // const parseCSV = (csvText) => {
    //     const lines = csvText.split('\n');
    //     const headers = lines[0].split(',').map(header => header.trim().replace(/"/g, ''));
    //     const data = [];

    //     for (let i = 1; i < lines.length; i++) {
    //         if (lines[i].trim() === '') continue;
    //         const values = lines[i].split(',').map(value => value.trim().replace(/"/g, ''));
    //         const row = {};
    //         headers.forEach((header, index) => {
    //             row[header] = values[index] || '';
    //         });
    //         data.push(row);
    //     }
    // };

    const parseCSV = (csvText) => {
        const parsed = Papa.parse(csvText, {
            header: true,
            skipEmptyLines: true,
            dynamicTyping: true
        });
        return parsed.data;
    };


    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile && selectedFile.type === 'text/csv') {
            setFile(selectedFile);

            // Parse CSV for preview
            const reader = new FileReader();
            reader.onload = (e) => {
                try {
                    const csvData = parseCSV(e.target.result);
                    setPreviewData(csvData);
                    setCsvParsed(true);
                } catch (error) {
                    toast.error('Error parsing CSV file');
                    setCsvParsed(false);
                }
            };
            reader.readAsText(selectedFile);
        } else {
            toast.error('Please select a valid CSV file.');
            event.target.value = null;
        }
    };


    const handleSubmit = async (event) => {
    event.preventDefault();
    setloading(true);
    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');
    const shipment_type = "forword";

    if (file) {
        const formData = new FormData();
        formData.append('csv_file', file);
        formData.append("shipment_type", shipment_type);

        try {
            const response = await axios.post(Base_Url + csvuplode, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'token': token,
                    'cus_id': cus_id,
                },
            });

            event.target.reset();

            if (response.data.status === "success") {
                toast.success(response.data.message || "File uploaded successfully!");
                setReqBody(response.data);
                navigate("/shipments/all");
                handleClose();
            } else {
                // 🧠 Check if validation errors exist
                if (response.data.errors && Array.isArray(response.data.errors)) {
                    // Show each error in a separate  
                    response.data.errors.forEach((err) => toast.error(err));
                } else {
                    toast.error(response.data.message || "File upload failed.");
                }
            } 
        } catch (error) {
            toast.error("Error uploading file: " + error.message);
        } finally {
            setloading(false);
        }
    }
};


    const PreviewModal = () => {
        if (!previewData || previewData.length === 0) return null;

        const headers = Object.keys(previewData[0]);

        return (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
                <div className={`bg-white/95 dark:bg-slate-900/95 backdrop-blur-xl rounded-3xl shadow-2xl w-11/12 max-w-6xl max-h-[90vh] overflow-hidden border border-white/20 dark:border-white/10 transform animate-in fade-in-0 zoom-in-95 duration-300`}>

                    {/* Enhanced Header with Gradient */}
                    <div className="flex justify-between items-center p-6 border-b border-gray-200/50 dark:border-gray-700/50 bg-gradient-to-r from-purple-600 to-pink-600 relative overflow-hidden">
                        {/* Animated Background Elements */}
                        <div className="absolute inset-0 bg-gradient-to-r from-purple-600/80 via-pink-600/80 to-indigo-600/80 animate-pulse"></div>

                        <div className="flex items-center space-x-3 relative z-10">
                            <div className="p-2 bg-white/20 rounded-full backdrop-blur-sm animate-pulse">
                                <FileText className="w-6 h-6 text-white" />
                            </div>
                            <div>
                                <h2 className="text-2xl font-bold text-white">
                                    Bulk Upload Preview
                                </h2>
                                <p className="text-purple-100 text-sm">Review your uploaded CSV data</p>
                            </div>
                            <Sparkles className="w-5 h-5 text-yellow-300 animate-pulse" />
                        </div>

                        <button
                            onClick={closePreviewModal}
                            className="p-2 bg-white/20 hover:bg-white/30 rounded-full transition-all duration-200 text-white hover:scale-110 transform relative z-10"
                        >
                            <X className="h-6 w-6" />
                        </button>

                        {/* Floating Elements */}
                        <div className="absolute top-2 right-16 animate-bounce">
                            <div className="w-2 h-2 bg-white/30 rounded-full"></div>
                        </div>
                        <div className="absolute top-6 right-20 animate-bounce" style={{ animationDelay: '300ms' }}>
                            <div className="w-1.5 h-1.5 bg-white/40 rounded-full"></div>
                        </div>
                    </div>

                    {/* Enhanced Content Area */}
                    <div className="overflow-auto max-h-[70vh] p-4 bg-gradient-to-br from-gray-50/50 to-white/50 dark:from-slate-800/50 dark:to-slate-900/50">

                        {/* Data Stats Card */}
                        <div className="mb-4 bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 rounded-xl p-4 border border-blue-200/50 dark:border-blue-800/50 backdrop-blur-sm">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center space-x-3">
                                    <div className="p-2 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full">
                                        <FileText className="w-4 h-4 text-white" />
                                    </div>
                                    <div>
                                        <h3 className="font-semibold text-gray-800 dark:text-gray-200 text-sm">Data Summary</h3>
                                        <p className="text-xs text-gray-600 dark:text-gray-400">
                                            Total Records: <span className="font-bold text-blue-600 dark:text-blue-400">{previewData.length}</span> |
                                            Columns: <span className="font-bold text-blue-600 dark:text-blue-400">{headers.length}</span>
                                        </p>
                                    </div>
                                </div>
                                <div className="text-right">
                                    <p className="text-xs text-gray-500 dark:text-gray-400">
                                        {file?.name}
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Enhanced Table */}
                        <div className="rounded-2xl overflow-hidden border border-gray-200/50 dark:border-gray-700/50 shadow-lg backdrop-blur-sm bg-white/80 dark:bg-slate-800/80">
                            <div className="overflow-x-auto">
                                <table className="w-full">
                                    {/* Enhanced Header */}
                                    <thead className="sticky top-0 bg-gradient-to-r from-indigo-500 to-purple-600 backdrop-blur-sm">
                                        <tr>
                                            {headers.map((header, index) => (
                                                <th
                                                    key={index}
                                                    className="p-4 text-left font-semibold text-white text-sm uppercase tracking-wide border-r border-white/20 last:border-r-0 relative group"
                                                >
                                                    <div className="flex items-center space-x-2">
                                                        <span>{header}</span>
                                                        <div className="w-1 h-1 bg-white/40 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></div>
                                                    </div>
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>

                                    {/* Enhanced Body */}
                                    <tbody>
                                        {previewData.slice(0, 50).map((row, rowIndex) => (
                                            <tr
                                                key={rowIndex}
                                                className={`${rowIndex % 2 === 0
                                                    ? 'bg-gray-50/50 dark:bg-gray-800/30'
                                                    : 'bg-white/50 dark:bg-gray-700/30'
                                                    } hover:bg-blue-50/70 dark:hover:bg-blue-900/20 transition-all duration-200`}
                                            >
                                                {headers.map((header, colIndex) => (
                                                    <td
                                                        key={colIndex}
                                                        className="p-4 text-sm text-gray-700 dark:text-gray-300 border-r border-gray-200/50 dark:border-gray-600/50 last:border-r-0 hover:bg-blue-50/30 dark:hover:bg-blue-900/10 transition-colors duration-150"
                                                    >
                                                        <div className="truncate max-w-xs" title={row[header]}>
                                                            {row[header]}
                                                        </div>
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Enhanced Footer Info */}
                        {previewData.length > 50 && (
                            <div className="text-center mt-4 p-3 bg-gradient-to-r from-amber-50 to-orange-50 dark:from-amber-900/20 dark:to-orange-900/20 rounded-xl border border-amber-200/50 dark:border-amber-800/50">
                                <div className="flex items-center justify-center space-x-2">
                                    <div className="w-2 h-2 bg-amber-500 rounded-full animate-pulse"></div>
                                    <span className="text-sm text-amber-700 dark:text-amber-300 font-medium">
                                        Showing first 50 rows of {previewData.length} total rows
                                    </span>
                                    <div className="w-2 h-2 bg-amber-500 rounded-full animate-pulse" style={{ animationDelay: '500ms' }}></div>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Enhanced Action Footer */}
                    <div className="p-4 bg-gradient-to-r from-gray-50 to-white dark:from-slate-800 dark:to-slate-900 border-t border-gray-200/50 dark:border-gray-700/50">
                        <div className="flex justify-between items-center">
                            <div className="flex items-center space-x-2 text-sm text-gray-600 dark:text-gray-400">
                                <CheckCircle className="w-4 h-4 text-green-500" />
                                <span>Data loaded successfully</span>
                            </div>
                            <div className="flex space-x-2">
                                <button
                                    onClick={closePreviewModal}
                                    className="px-4 py-2 bg-gradient-to-r from-gray-500 to-gray-600 hover:from-gray-600 hover:to-gray-700 text-white rounded-lg font-medium text-sm transition-all duration-200 transform hover:scale-105"
                                >
                                    Close Preview
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    if (!isopen) return null;

    return (
        <Dialog
            open={isopen}
            onClose={onClose}
            maxWidth="md"
            sx={{
                '& .MuiDialog-paper': {
                    width: '90%',
                    maxWidth: '900px',
                    height: '75vh',
                    borderRadius: '20px',
                    background: 'linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)',
                    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                    overflow: 'hidden',
                }
            }}
        >
            <DialogTitle className="relative p-0 m-0">
                <div className="bg-gradient-to-r from-purple-600 via-customPurple to-customPurple text-white p-2 rounded-custom relative overflow-hidden">
                    {/* <div className="absolute inset-0 bg-gradient-to-r from-purple-600/20 to-indigo-600/20 backdrop-blur-sm"></div> */}
                    <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full transform translate-x-16 -translate-y-16"></div>
                    <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/10 rounded-full transform -translate-x-12 translate-y-12"></div>

                    <div className="relative z-10">
                        <h2 className="text-xl font-bold text-center mb-2 tracking-tight">
                            🚀 Bulk Order Upload
                        </h2>
                        <p className="text-center text-purple-100 text-sm font-medium">
                            Upload your CSV file to create multiple orders instantly
                        </p>
                    </div>

                    <button
                        onClick={handleCloseBulk}
                        className="absolute top-2 right-2 z-20 w-10 h-10 bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                    >
                        <IoIosCloseCircle size={24} className="text-white" />
                    </button>
                </div>
            </DialogTitle>

            <DialogContent
                className={`p-0 ${isDarkMode ? "dark:bg-darkmodeColor" : ""}`}
                sx={{
                    overflowY: 'auto',
                    '&::-webkit-scrollbar': {
                        width: '6px',
                    },
                    '&::-webkit-scrollbar-track': {
                        background: 'transparent',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        background: '#e2e8f0',
                        borderRadius: '3px',
                    },
                }}
            >
                <div className={`p-4 ${isDarkMode ? "dark:bg-darkmodeColor text-white" : ""}`}>
                    <form onSubmit={handleSubmit} className="space-y-8">
                        {/* Enhanced File Upload Zone */}
                        <div className="relative">
                            <label
                                htmlFor="dropzone-file"
                                className={`group relative flex flex-col items-center justify-center w-full h-15 border-2 border-dashed rounded-2xl cursor-pointer transition-all duration-300 transform hover:scale-[1.02] ${file
                                    ? 'border-green-400 bg-green-50 hover:bg-green-100'
                                    : 'border-gray-300 bg-gray-50 hover:bg-gray-100 hover:border-purple-400'
                                    } ${isDarkMode ? 'dark:border-gray-600 dark:bg-gray-800 dark:hover:bg-gray-700' : ''}`}
                            >
                                <div className="absolute inset-0 bg-gradient-to-br from-purple-500/5 to-indigo-500/5 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                                <div className="relative z-10 flex flex-col items-center justify-center pt-8 pb-8">
                                    <div className={`relative mb-6 ${file ? 'animate-bounce' : ''}`}>
                                        {file ? (
                                            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                                                <FileText className="w-4 h-4 text-green-600" />
                                            </div>
                                        ) : (
                                            <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center group-hover:bg-purple-200 transition-colors">
                                                <FiUploadCloud className="w-4 h-4 text-purple-600" />
                                            </div>
                                        )}

                                        {!file && (
                                            <div className="absolute -top-2 -right-2 w-6 h-6 bg-indigo-500 rounded-full flex items-center justify-center">
                                                <span className="text-white text-xs font-bold">+</span>
                                            </div>
                                        )}
                                    </div>

                                    <div className="text-center">
                                        <p className={`mb-3 text-lg font-semibold ${file ? 'text-green-700' : 'text-gray-700'} ${isDarkMode ? 'dark:text-white' : ''}`}>
                                            {file ? '✅ File Selected!' : '📁 Drop your CSV file here'}
                                        </p>
                                        <p className={`text-sm ${file ? 'text-green-600' : 'text-gray-500'} ${isDarkMode ? 'dark:text-gray-300' : ''}`}>
                                            <span className="font-medium">Click to browse</span> or drag and drop
                                        </p>
                                        <p className={`text-xs mt-2 ${file ? 'text-green-500' : 'text-gray-400'} ${isDarkMode ? 'dark:text-gray-400' : ''}`}>
                                            CSV files only • Max 10MB
                                        </p>
                                    </div>
                                </div>

                                <input
                                    id="dropzone-file"
                                    type="file"
                                    className="hidden"
                                    accept=".csv"
                                    onChange={handleFileChange}
                                />
                            </label>
                        </div>

                        {/* File Info Section */}
                        {file && (
                            <div className="space-y-4 animate-fadeIn">
                                <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-xl p-4">
                                    <div className="flex items-center space-x-3">
                                        <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                                            <FileText className="w-5 h-5 text-green-600" />
                                        </div>
                                        <div className="flex-1">
                                            <p className="font-semibold text-green-800">{file.name}</p>
                                            <p className="text-sm text-green-600">
                                                {(file.size / 1024 / 1024).toFixed(2)} MB
                                            </p>
                                        </div>
                                        <div className="flex items-center space-x-2">
                                            <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
                                            <span className="text-sm text-green-700 font-medium">Ready</span>
                                        </div>
                                    </div>
                                </div>

                                {/* Preview Button */}
                                {csvParsed && previewData.length > 0 && (
                                    <button
                                        type="button"
                                        onClick={handlePreviewClick}
                                        className="w-full flex items-center justify-center space-x-3 px-6 py-4 bg-gradient-to-r from-blue-500 via-purple-500 to-indigo-500 hover:from-blue-600 hover:via-purple-600 hover:to-indigo-600 text-white rounded-xl font-semibold text-sm transition-all duration-300 transform hover:scale-105 hover:shadow-lg group"
                                    >
                                        <Eye className="w-5 h-5 group-hover:animate-pulse" />
                                        <span>Preview Data</span>
                                        <div className="bg-white/20 px-2 py-1 rounded-full text-xs">
                                            {previewData.length} rows
                                        </div>
                                    </button>
                                )}

                                {/* Loading State */}
                                {!csvParsed && (
                                    <div className="flex items-center justify-center space-x-3 p-4 bg-amber-50 border border-amber-200 rounded-xl">
                                        <div className="w-5 h-5 border-2 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
                                        <span className="text-amber-700 font-medium">Parsing CSV file...</span>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Submit Button */}
                        <button
                            type="submit"
                            disabled={!file || loading}
                            className={`w-full px-6 py-4 text-white font-bold text-lg rounded-xl transition-all duration-300 transform hover:scale-105 hover:shadow-xl ${!file || loading
                                ? 'bg-gray-400 cursor-not-allowed'
                                : 'bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 active:scale-95'
                                }`}
                        >
                            {loading ? (
                                <div className="flex items-center justify-center space-x-2">
                                    <Spinner />
                                    <span>Processing...</span>
                                </div>
                            ) : (
                                <div className="flex items-center justify-center space-x-2">
                                    <span>🚀 Create Bulk Orders</span>
                                </div>
                            )}
                        </button>
                    </form>

                    {/* Sample Download Section */}
                    <div className="mt-8 p-6 bg-gradient-to-r from-gray-50 to-gray-100 rounded-xl border border-gray-200">
                        <div className="text-center">
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">
                                💡 Need a template?
                            </h3>
                            <p className="text-sm text-gray-600 mb-4">
                                Download our sample CSV file to see the required format
                            </p>
                            <a
                                href="/sampleFile/Sample.csv"
                                download="Sample.csv"
                                className="inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800 text-white rounded-xl font-semibold text-sm transition-all duration-300 transform hover:scale-105 hover:shadow-lg group"
                            >
                                <FiDownload className="w-5 h-5 mr-2 group-hover:animate-bounce" />
                                Download Sample CSV
                            </a>
                        </div>
                    </div>
                </div>

                {/* Modals */}
                <ConfirmBulkOrder
                    isopen={isPopupOpen}
                    onClose={handleClose}
                    data={reqBody}
                    file={file}
                />
                {showPreview && <PreviewModal />}
            </DialogContent>
        </Dialog>
    );
};
export default UploadBulk;